class HlsBlob {
  generateBlobLink(data: string): string {
    const encBlob = new Blob([data], {
      type: "application/octet-stream",
    });

    return URL.createObjectURL(encBlob);
  }
}

export default HlsBlob;
